import LoginDevices from "../components/LoginDevices";
import useLoginDevices from "../hooks/useLoginDevices";
const LoginDevicesPages = () => {
    const LoginDevicesProps = useLoginDevices();
    return <LoginDevices {...LoginDevicesProps} />
};
export default LoginDevicesPages; 